import styles from "./index.module.scss";

type TSortProps = {
  setOldest: (key: boolean | ((key: boolean) => boolean)) => void;
  oldest: boolean;
};

export default function ButtonSort({ setOldest, oldest }: TSortProps): JSX.Element {
  return (
    <div className={styles.btn} onClick={() => setOldest((prev: boolean) => !prev)} data-e="notes-sortbtn">
      <div className={styles.btnTitle}>{oldest ? "Najstarsze" : "Najnowsze"}</div>
      <div className={`${styles.btnIcon} ${oldest ? styles.btnIcon_up : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
          <path data-name="Path 501" d="M0 0h12v12H0z" fill="none" />
          <path
            data-name="Path 502"
            d="m12 8-.7-.7-2.8 2.79V4h-1v6.085L4.71 7.29 4 8l4 4z"
            transform="translate(-2 -2)"
            fill="#222"
          />
        </svg>
      </div>
    </div>
  );
}
